import * as React from 'react'
import { FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { defaultFilters } from '@user/store/lead/filters'
import { IOption } from '@user/components/Filters'

import { currencyString } from '@sales-center/common'
import { TotalAndDescription } from '../../../TotalAndDescription'
import { useSaveLeadFilters } from '@user/store/lead/hooks'

interface Props {
  count: number
  value: number
  salesTeam?: IOption
  salesTeams?: IOption[]
  assignee?: IOption
  assignees?: IOption[]
  canViewLeads: boolean
}

export const LeadsToQualify: FC<Props> = (props) => {
  const { count, value, salesTeams, assignees, canViewLeads } = props
  const navigate = useNavigate()

  const saveLeadFilters = useSaveLeadFilters()

  const leadsToQualifyCallToAction = useCallback(() => {
    saveLeadFilters({
      ...defaultFilters,
      filters: {
        ...defaultFilters.filters,
        salesTeamIds: {
          ...defaultFilters.filters.salesTeamIds,
          value: { mode: 'any', options: salesTeams || [] },
        },
        assignee: {
          ...defaultFilters.filters.assignee,
          value: { mode: 'any', options: assignees || [] },
        },
      },
    })

    navigate('/leads')
  }, [assignees, navigate, salesTeams, saveLeadFilters])

  return (
    <TotalAndDescription
      testIdPrefix="leads-widget"
      callToActionFunction={leadsToQualifyCallToAction}
      callToActionText="Follow Up"
      callToActionAllowed={canViewLeads}
      description={
        <>
          These Leads have a total value of{` `}
          <b>{`$${currencyString(value)}`}</b>. Qualify these Leads to convert
          them into Opportunities.
        </>
      }
      headerText={`${count == 1 ? 'Lead' : 'Leads'} to Qualify`}
      total={count}
    />
  )
}

LeadsToQualify.displayName = 'LeadsToQualify'
